import { getLeftPosition } from './util'

import styles from './CurrentMonthIndicator.module.scss'

export interface CurrentMonthIndicatorProps {
  index: number
}

export const CurrentMonthIndicator = ({ index }: CurrentMonthIndicatorProps) => (
  <div className={styles.container} style={{ left: getLeftPosition(index) }}>
    <div className={styles.el} data-qa='current-month-indicator' />
  </div>
)
